import api from '../../../../../api/client';
import { DASHBOARD } from '../../../../../api/endpoints';
import { handleApiError, handleApiResponse } from '../../../../../api/handlers';

export async function getClientDashboard(params = {}) {
  try {
    const response = await api.get(DASHBOARD.CLIENT_MANAGEMENT, {
      params,
    });
    const data = handleApiResponse(response);
    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}
